import React, {ReactNode, PureComponent} from 'react';

import {CartItemType} from '../../types';
import {BaseCartItem} from '../baseCartItem/baseCartItem';
import {BaseQtySwitcherConnected} from '../baseQtySwitcher/baseQtySwitcher';

type PropsType = {
    item: CartItemType;
};

/**
 * Cart accessory item.
 */
export class CartItemAccessory extends PureComponent<PropsType> {
    /**
     * Render component
     * @return {ReactNode} - rendered component
     */
    render(): ReactNode {
        const {item} = this.props;

        return (
            <BaseCartItem editable={false} item={item}>
                <></>
                <BaseQtySwitcherConnected id={item.id} />
            </BaseCartItem>
        );
    }
}
